// SessionLoader.js
// -----------------------------------------------------------------------------
// Ecran de chargement neutre affiche pendant la validation de la session.
// Volontairement sans header, sans menu et sans donnee metier : l'utilisateur
// ne doit rien voir de la plateforme tant que la session n'est pas confirmee.
// -----------------------------------------------------------------------------
import React from "react";
import { Spinner } from "reactstrap";

const SessionLoader = () => {
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#ffffff",
        zIndex: 9999,
      }}
    >
      <Spinner color="primary" style={{ height: "3rem", width: "3rem" }}>
        Loading...
      </Spinner>
    </div>
  );
};

export default SessionLoader;
